import { render, staticRenderFns } from "./distributed_response.vue?vue&type=template&id=77243f4e&scoped=true&"
import script from "./distributed_response.vue?vue&type=script&lang=js&"
export * from "./distributed_response.vue?vue&type=script&lang=js&"
import style0 from "./distributed_response.vue?vue&type=style&index=0&id=77243f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77243f4e",
  null
  
)

export default component.exports